<template>
	<button fab type="button" v-on="$listeners">
		<v-icon>add</v-icon>
	</button>
</template>

<script>
	export default {
		name: 'add-button',
	};
</script>

<style lang="scss" scoped>
	button {
		i {
			color: color(green-icon) !important;
		}
	}

	button:hover {
		
	}
</style>



// WEBPACK FOOTER //
// src/components/shared/buttons/add-button.vue